import { ServiceModel } from '@bsuccess/models/project/service.model';

export interface State {
    others: ServiceModel[];
}

export const initialState: State = {
    others: [],
};
